const hasAnyPermission = (permissionObject?: Record<string, boolean> | null) => {
  if (!permissionObject) return false
  return Object.values(permissionObject).some((value) => value === true)
}

export function getDefaultLandingPage(user?: Record<string, any> | null) {
  if (!user) return '/home'

  if (hasAnyPermission(user.graphic_design)) {
    return '/orders'
  }

  if (hasAnyPermission(user.customer_service)) {
    return '/customer-service'
  }

  if (hasAnyPermission(user.refund_requests)) {
    return '/requests/listing'
  }

  if (
    user.accounts?.add_business_days ||
    user.accounts?.add_rush_days ||
    user.accounts?.add_wholesale_days
  ) {
    return '/turnaround-time'
  }

  if (user.accounts?.view_accounts) {
    return '/accounts'
  }

  if (user.accounts?.manage_roles) {
    return '/roles'
  }

  if (hasAnyPermission(user.digital_previews)) {
    return '/mockups'
  }

  return '/home'
}
